import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { observer } from "mobx-react";
import PrivateIndicator from "../PrivateIndicator/PrivateIndicator";
import Loader from "../Loader";
import Icon from "../../Styled/Icon";
import Styles from "./data-catalog-group.scss";
import Box from "../../Styled/Box";
import Text from "../../Styled/Text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CatalogGroupButton = styled.button.withConfig({
  displayName: "CatalogGroup__CatalogGroupButton",
  componentId: "sc-1102pmx-0"
})(["", ""], props => "\n    &:hover,\n    &:focus {\n      color: ".concat(props.theme.textLight, ";\n      background-color: ").concat(props.theme.modalHighlight, ";\n      svg {\n        fill: white;\n      }\n    }\n    ").concat(props.active && "\n        color: ".concat(props.theme.textLight, ";\n        background-color: ").concat(props.theme.modalHighlight, ";\n        svg {\n          fill: white;\n        }\n      "), "\n    "));

/**
 * Dumb component that encapsulated the display logic for a catalog group.
 *
 * @constructor
 */
const CatalogGroup = observer(props => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs("li", {
    className: Styles.root,
    children: [/*#__PURE__*/_jsxs(Text, {
      fullWidth: true,
      primary: !props.selected && props.isPrivate,
      children: [props.displayGroup === true && /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsx("button", {
          type: "button"
          // TODO: apply unique styles
          ,
          className: Styles.addRemoveButton,
          title: props.allItemsLoaded ? t("models.catalog.removeAll") : t("models.catalog.addAll")
          // onClick should call addAll function which I should move out of GroupPreview to separate service file
          ,
          onClick: props.addRemoveButtonFunction,
          children: /*#__PURE__*/_jsx(Icon, {
            glyph: props.allItemsLoaded ? Icon.GLYPHS.minusList : Icon.GLYPHS.plusList
          })
        })
      }), /*#__PURE__*/_jsxs(CatalogGroupButton, {
        type: "button",
        className: classNames(Styles.btnCatalog, {
          [Styles.btnCatalogTopLevel]: props.topLevel
        }, {
          [Styles.btnIsOpen]: props.open
        }, {
          [Styles.isPreviewed]: props.selected
        }),
        title: props.title,
        onClick: props.onClick,
        active: props.selected,
        children: [!props.topLevel && /*#__PURE__*/_jsx("span", {
          className: Styles.folder,
          children: props.open ? /*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS.folderOpen
          }) : /*#__PURE__*/_jsx(Icon, {
            glyph: Icon.GLYPHS.folder
          })
        }), /*#__PURE__*/_jsxs(Box, {
          justifySpaceBetween: true,
          children: [/*#__PURE__*/_jsx(Box, {
            children: props.text
          }), /*#__PURE__*/_jsxs(Box, {
            alignItemsFlexStart: true,
            children: [props.isPrivate && /*#__PURE__*/_jsx(PrivateIndicator, {}), /*#__PURE__*/_jsx("span", {
              className: classNames(Styles.caret, {
                [Styles.offsetRight]: props.removable
              }),
              children: props.open ? /*#__PURE__*/_jsx(Icon, {
                glyph: Icon.GLYPHS.opened
              }) : /*#__PURE__*/_jsx(Icon, {
                glyph: Icon.GLYPHS.closed
              })
            }), props.removable && /*#__PURE__*/_jsx("button", {
              type: "button",
              className: Styles.trashGroup,
              title: t("dataCatalog.groupRemove"),
              onClick: props.removeUserAddedData,
              children: /*#__PURE__*/_jsx(Icon, {
                glyph: Icon.GLYPHS.trashcan
              })
            })]
          })]
        })]
      })]
    }), props.open && /*#__PURE__*/_jsxs("ul", {
      className: classNames(Styles.catalogGroup, {
        [Styles.catalogGroupLowerLevel]: !props.topLevel
      }),
      children: [props.loading && /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx(Loader, {})
      }, "loader"), !props.loading && props.children.length === 0 && props.emptyMessage && /*#__PURE__*/_jsx("li", {
        className: classNames(Styles.label, Styles.labelNoResults),
        children: props.emptyMessage
      }, "empty"), !props.loading ? props.children : null]
    })]
  });
});
CatalogGroup.propTypes = {
  text: PropTypes.string,
  isPrivate: PropTypes.bool,
  title: PropTypes.string,
  topLevel: PropTypes.bool,
  open: PropTypes.bool,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  selected: PropTypes.bool,
  removable: PropTypes.bool,
  removeUserAddedData: PropTypes.func,
  displayGroup: PropTypes.bool,
  allItemsLoaded: PropTypes.bool,
  addRemoveButtonFunction: PropTypes.func
};
export default CatalogGroup;